import { css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const container = css`
  ${breakpoint.up('smMd')} {
    margin: 0 auto;
    padding: 0 ${size[20]};
    max-width: ${width.container.large};
  }
`

export const headlineWrapper = css`
  text-align: center;
  margin-top: 4em;

  h2 {
    font-size: ${pxToRem(36)};
    font-weight: 600;
  }

  & p {
    font-size: ${fontSize.xxs};
  }

  ${breakpoint.up('smMd')} {
    max-width: 35em;
    margin-right: auto;
    margin-left: auto;

    h2 {
      font-size: ${pxToRem(48)};
      font-weight: 700;
      letter-spacing: -1px;
    }

    & p {
      font-size: ${fontSize.xs};
      letter-spacing: 2px;
      margin-bottom: ${size[8]};
    }
  }
`

export const boxes = css`
  display: flex;
  flex-direction: column;
  gap: ${size[16]};
  margin: 0 ${size[20]};

  ${breakpoint.up('smMd')} {
    margin: 0;
  }
`
